import ApiService from "../common/apiService";
import TokenService from "../common/tokenService";
import {
  CLEAR_CATEGORY_FOLDER,
  SET_CATEGORY_FOLDER,
  CLEAR_SUBCATEGORY_FOLDER,
  SET_SUBCATEGORY_PUBLICATION,
  GET_SUBSCRIPTION_CATEGORY,
  ADD_PUBLICATION_SUBSCRIPTION,
  DELETE_PUBLICATION_SUBSCRIPTION,
  ADD_PUBLICATION_NOTIFICATION,
  DELETE_PUBLICATION_NOTIFICATION,
  CLEAR_SUBSCRIPTION_PUBLICATIONS
} from "./actions.type";

const SubscriptionModule = {
  state: {
    errors: null,
    token: TokenService.getToken(),
    twoFactorAuth: {
      method: null,
      completed: null
    },
    folderId: null,
    category_id:null,
    categories: [],
    subCategories: [],
    publications:[],
  },
  mutations:{
    clearPublications(state) {
      state.publications = [];
    },
    setSubscriptionCategories(state, categories){
      state.categories = categories;
    },
    clearCategoryFolder(state) {
      state.category_id = null;
      state.subCategories = [];
    },
    setCategoryFolder(state,category_id){
      state.category_id = category_id;
      let cat = state.categories.find(el => {
        if (el.id === category_id) {
          return el
        }
      });
      if(cat.children.length > 0)
      {
        state.subCategories = state.categories.find(el => el.id === category_id).children;
      }else{
        state.subCategories = cat;
      }
    },
    clearSubcategoryFolder(state) {
      state.folderId = null;
      state.publications = [];
    },
    setSubscription(state,subscriptions){
      state.subscriptions = subscriptions;
    },
    setSubCategoryPublication(state,data){
      state.folderId = data.folder_id;
      state.publications = data.data;
    }
  },
  getters: {
    getCategoryId(state){
      return state.category_id;
    }
  },
  actions: {
    async [GET_SUBSCRIPTION_CATEGORY](context,payload){
      let res = {};
      let url = "/categories?withPublication=true";
      await ApiService.get(url)
        .then(response => {
          let items = response.data;
          context.commit('setSubscriptionCategories',items.data);
          res = items;
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    [CLEAR_CATEGORY_FOLDER](context){
      context.commit('clearCategoryFolder');
    },
    [SET_CATEGORY_FOLDER](context,payload){
      context.commit('setCategoryFolder',payload);
    },
    [CLEAR_SUBCATEGORY_FOLDER](context){
      context.commit('clearSubcategoryFolder');
    },
    async [SET_SUBCATEGORY_PUBLICATION](context,payload){
      let category = payload;
      let res = {};
      let url = `/publications/category/${category}`;
      await ApiService.get(url)
        .then(response => {
          res = response;
          res.folder_id = payload;
          context.commit('setSubCategoryPublication', res);
        })
        .catch(error => {
          //TODO
          console.log(error);
        });
    },
    async [ADD_PUBLICATION_SUBSCRIPTION](context,payload){
      let res = {};
      let url = "/subscriptions";
      await ApiService.post(url,{category_ids:payload})
        .then(response => {
          res = response.data;
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    async [DELETE_PUBLICATION_SUBSCRIPTION](context,payload){
      let res = {};
      let url = "/subscriptions/"+JSON.stringify(payload);
      await ApiService.delete(url)
        .then(response => {
          res = response.data;
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    async [ADD_PUBLICATION_NOTIFICATION](context,payload){
      let res = {};
      let url = "/subscriptions?type=notification";
      await ApiService.post(url,{category_ids:payload})
        .then(response => {
          res = response.data;
        })
        .catch(error => {
          res = error;
        })
      return res
    },
    async [DELETE_PUBLICATION_NOTIFICATION](context,payload){
      let res = {};
      let url = "/subscriptions/"+JSON.stringify(payload)+'?type=notification';
      await ApiService.delete(url)
        .then(response => {
          res = response.data;
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    [CLEAR_SUBSCRIPTION_PUBLICATIONS](context) {
      context.commit('clearPublications');
    }

  }
};
export default SubscriptionModule;
